import { useApiGet } from '@sierralabs/core-ui';
export function useExportSite(id) {
    const { data, isLoading, error, get } = useApiGet(`sites/${id}/export`);
    return {
        exportSiteData: data,
        isLoading,
        exportError: error,
        exportSite: get
    };
}
//# sourceMappingURL=useExportSite.js.map